import Immutable from 'seamless-immutable';
import _ from 'lodash';

function create(experienceTotals = _defaultExperienceTotals) {
  const result = _.reduce(experienceTotals, (acc, { event_type, count }) => ({ ...acc, [event_type]: count }), {});
  return Immutable(result, { prototype: model });
}

function deserialize(experienceTotals) {
  const result = _.pick(experienceTotals, _keys);
  return create(result);
}

const model = {};

const _keys = ['count', 'event_type'];
const _defaultExperienceTotals = {};

export default {
  create,
  deserialize,
};
